import * as api from '../api'
import { NOTE_PENDING, SURVEY_VOTE_RECEIVED, SURVEY_VOTES_RECEIVED } from '../constants/actionTypes.js'



export const addVote = (id, idChoice, idEntry) => async (dispatch, getState) => {
    try {
        const { data } = await api.addVote(id, {idChoice, idEntry})

        // Note received

        dispatch({ type : SURVEY_VOTE_RECEIVED, payload: {id, idChoice, idEntry}})
    } catch(error){
        console.log(error.message)
    }
}

export const addVotes = (id, votes) => async (dispatch, getState) => {
    try {
        const { data } = await api.addVotes(id, votes)

        // Note received

        dispatch({ type : SURVEY_VOTES_RECEIVED, payload: {id, votes}})
    } catch(error){
        console.log(error.message)
    }
}

export const pendingNote = (id, player, note) => async (dispatch, getState) => {
    try {
        dispatch({ type : NOTE_PENDING, payload: {idNotation : id, target : player._id, note}})
    } catch(error){
        console.log(error.message)
    }
}